import { type ElementType } from 'react';

import { Typography, type TypographyProps } from '@craft/ui/components/typography';

export type DisplayMenuItemProps<E extends ElementType> = TypographyProps<E>;

export const DisplayMenuItem = <E extends ElementType>(props: DisplayMenuItemProps<E>) => (
  <Typography
    color='text.secondary'
    fontSize='14px'
    fontWeight={500}
    letterSpacing='0.1px'
    lineHeight='32px'
    paddingX={2}
    role='presentation'
    {...props}
  />
);
